const textQueries = `
  reviewsLegalText: pair(pairKey: "reviewsLegalText") {
    key
    value
  }
  omniStoreUnavailable: pair(pairKey: "omniStoreUnavailable") {
    key
    value
  }
  omniStoreAvailable: pair(pairKey: "omniStoreAvailable") {
    key
    value
  }
  omniStoreOrder: pair(pairKey: "omniStoreOrder") {
    key
    value
  }
  omniStoreTitle: pair(pairKey: "omniStoreTitle") {
    key
    value
  }
  omniStoreAction: pair(pairKey: "omniStoreAction") {
    key
    value
  }
  omniStoreAvailability: pair(pairKey: "omniStoreAvailability") {
    key
    value
  }
  omniStoreActionAlt: pair(pairKey: "omniStoreActionAlt") {
    key
    value
  }
  omniStoreSize: pair(pairKey: "omniStoreSize") {
    key
    value
  }
  shopSimilarCta: pair(pairKey: "shopSimilarCta") {
    key
    value
  }
  shopSimilarLabel: pair(pairKey: "shopSimilarLabel") {
    key
    value
  }
  shopSimilarHeader: pair(pairKey: "shopSimilarHeader") {
    key
    value
  }
  swatchUrgencyMessage: pair(pairKey: "swatchUrgencyMessage") {
    key
    value
  }
  backorderUrgencyMessage: pair(pairKey: "backorderUrgencyMessage") {
    key
    value
  }
  sizeUrgencyMessage: pair(pairKey: "sizeUrgencyMessage") {
    key
    value
  }
  atbUrgencyTitle: pair(pairKey: "atbUrgencyTitle") {
    key
    value
  }
  finalSaleText: pair(pairKey: "finalSaleText") {
    key
    value
  }
  ofText: pair(pairKey: "ofText") {
    key
    value
  }
  unavailableText: pair(pairKey: "unavailable") {
    key
    value
  }
  jeansShortLocationHeader: pair(pairKey: "jeansShortLocationHeader") {
    key
    value
  }
  cityStateZip: pair(pairKey: "cityStateZip") {
    key
    value
  }
  selectAStore: pair(pairKey: "selectAStore") {
    key
    value
  }
  or: pair(pairKey: "or") {
    key
    value
  }
  storesInRadius: pair(pairKey: "storesInRadius") {
    key
    value
  }
  findingStoresNear: pair(pairKey: "findingStoresNear") {
    key
    value
  }
  productAvailLegalText: pair(pairKey: "productAvailLegalText") {
    key
    value
  }
  promotionLegalText: pair(pairKey: "promotionLegalText") {
    key
    value
  }
  reviewsLegalText: pair(pairKey: "reviewsLegalText") {
    key
    value
  }
  noStoresFoundNear: pair(pairKey: "noStoresFoundNear") {
    key
    value
  }
  searchDifferentLocation: pair(pairKey: "searchDifferentLocation") {
    key
    value
  }
  findStoreError: pair(pairKey: "findStoreError") {
    key
    value
  }
  mapAndHours: pair(pairKey: "mapAndHours") {
    key
    value
  }
  nearMe: pair(pairKey: "nearMe") {
    key
    value
  }
  storeNear: pair(pairKey: "storeNear") {
    key
    value
  }
  homeDelivery: pair(pairKey: "homeDelivery") {
    key
    value
  }
  sameDayDelivery: pair(pairKey: "sameDayDelivery") {
    key
    value
  }
  sizeGuideLinkText: pair(pairKey: "sizeGuideLinkText") {
    key
    value
  }
  sizeGuideHeader: pair(pairKey: "sizeGuideHeader") {
    key
    value
  }
  saveForLater: pair(pairKey: "saveForLater") {
    key
    value
  }
  processingSave: pair(pairKey: "processingSave") {
    key
    value
  }
  saved: pair(pairKey: "saved") {
    key
    value
  }
  processingRemove: pair(pairKey: "processingRemove") {
    key
    value
  }
  shareLabel: pair(pairKey: "shareLabel") {
    key
    value
  }
  shareMessage: pair(pairKey: "shareMessage") {
    key
    value
  }
  sizeGuideSubtitle: pair(pairKey: "sizeGuideSubtitle") {
    key
    value
  }
  sizeGuideMessagingGirls: pair(pairKey: "sizeGuideMessagingGirls") {
    key
    value
  }
  sizeGuideMessagingGuys: pair(pairKey: "sizeGuideMessagingGuys") {
    key
    value
  }
  sizeGuideRegionSelector: pair(pairKey: "sizeGuideRegionSelector") {
    key
    value
  }
  sizeGuideInch: pair(pairKey: "sizeGuideInch") {
    key
    value
  }
  sizeGuideCm: pair(pairKey: "sizeGuideCm") {
    key
    value
  }
  sizeGuideSizeFit: pair(pairKey: "sizeGuideSizeFit") {
    key
    value
  }
  sizeGuideHowMeasure: pair(pairKey: "sizeGuideHowMeasure") {
    key
    value
  }
  earlyAccessDesc: pair(pairKey: "pdpEarlyAccessDesc") {
    key
    value
  }
  earlyAccessSignIn: pair(pairKey: "pdpEarlyAccessSignIn") {
    key
    value
  }
  earlyAccessText: pair(pairKey: "pdpEarlyAccessText") {
    key
    value
  }
  addToBagReady: pair(pairKey: "addToBagReady") {
    key
    value
  }
  updateToBagReady: pair(pairKey: "updateToBagReady") {
    key
    value
  }
  addToBagProcessing:  pair(pairKey: "addToBagProcessing") {
    key
    value
  }
  addToBagAdded:  pair(pairKey: "addToBagAdded") {
    key
    value
  }
  updateToBagSuccess:  pair(pairKey: "updateToBagSuccess") {
    key
    value
  }
  addToMyBagReady:  pair(pairKey: "addToMyBagReady") {
    key
    value
  }
  addedToMyBag:  pair(pairKey: "addedToMyBag") {
    key
    value
  }
  addToBagUrgency:  pair(pairKey: "addToBagUrgency") {
    key
    value
  }
  addToBagSoldOut: pair(pairKey: "addToBagSoldOut") {
    key
    value
  }
  shownInText: pair(pairKey: "shownIn") {
    key
    value
  }
  colorText: pair(pairKey: "colorText") {
    key
    value
  }
  sizeAndFitAccordionHeaderText: pair(pairKey: "sizeAndFitAccordionHeaderText") {
    key
    value
  }
  fitHeaderText: pair(pairKey: "fitHeader") {
    key
    value
  }
  modelText: pair(pairKey: "modelSpecs") {
    key
    value
  }
  wearingSizeText: pair(pairKey: "wearingSize") {
    key
    value
  }
  inSizeText: pair(pairKey: "inSize") {
    key
    value
  }
  garmentHeaderText: pair(pairKey: "garmentHeader") {
    key
    value
  }
  baseText: pair(pairKey: "baseMeasurementSize") {
    key
    value
  }
  xtraShortText: pair(pairKey: "baseXShortMeasurementSize") {
    key
    value
  }
  shortText: pair(pairKey: "baseShortMeasurementSize") {
    key
    value
  }
  regularText: pair(pairKey: "baseRegularMeasurementSize") {
    key
    value
  }
  longText: pair(pairKey: "baseLongMeasurementSize") {
    key
    value
  }
  legOpeningText: pair(pairKey: "baseLegOpeningMeasurementSize") {
    key
    value
  }
  sleeveLengthText: pair(pairKey: "baseSleeveLengthMeasurementSize") {
    key
    value
  }
  shoulderText: pair(pairKey: "baseShoulderMeasurementSize") {
    key
    value
  }
  frontRiseText: pair(pairKey: "baseFrontRiseMeasurementSize") {
    key
    value
  }
  howToMeasureMaleText: pair(pairKey: "measurementGuideMaleAbove") {
    key
    value
  }
  howToMeasureFemaleText: pair(pairKey: "measurementGuideFemaleAbove") {
    key
    value
  }
  howToMeasureKidsMaleText: pair(pairKey: "measurementGuideKidsMaleAbove") {
    key
    value
  }
  howToMeasureKidsFemaleText: pair(pairKey: "measurementGuideKidsFemaleAbove") {
    key
    value
  }
  skirtLengthText: pair(pairKey: "baseSkirtLengthMeasurementSize") {
    key
    value
  }
  baseMeasurementTooltipHeader: pair(pairKey: "baseMeasurementTooltipHeader") {
    key
    value
  }
  baseMeasurementTooltipText: pair(pairKey: "baseMeasurementTooltipText") {
    key
    value
  }
  baseFrontRiseTooltipHeader: pair(pairKey: "baseFrontRiseTooltipHeader") {
    key
    value
  }
  baseFrontRiseTooltipText: pair(pairKey: "baseFrontRiseTooltipText") {
    key
    value
  }
  baseLegOpeningTooltipHeader: pair(pairKey: "baseLegOpeningTooltipHeader") {
    key
    value
  }
  baseLegOpeningTooltipText: pair(pairKey: "baseLegOpeningTooltipText") {
    key
    value
  }
  baseSleeveLengthTooltipHeader: pair(pairKey: "baseSleeveLengthTooltipHeader") {
    key
    value
  }
  baseSleeveLengthTooltipText: pair(pairKey: "baseSleeveLengthTooltipText") {
    key
    value
  }
  baseShoulderTooltipHeader: pair(pairKey: "baseShoulderTooltipHeader") {
    key
    value
  }
  baseShoulderTooltipText: pair(pairKey: "baseShoulderTooltipText") {
    key
    value
  }
  baseSkirtLengthTooltipHeader: pair(pairKey: "baseSkirtLengthTooltipHeader") {
    key
    value
  }
  baseSkirtLengthTooltipText: pair(pairKey: "baseSkirtLengthTooltipText") {
    key
    value
  }
  mostRecommended: pair(pairKey: "mostRecommended") {
    key
    value
  }
  mostRecommendedWithParam: pair(pairKey: "mostRecommendedWithParam") {
    key
    value
  }
  fitVerySmallTitleDescription: pair(pairKey: "fitVerySmallTitleDescription") {
    key
    value
  }
  fitSmallTitleDescription: pair(pairKey: "fitSmallTitleDescription") {
    key
    value
  }
  fitSomewhatSmallTitleDescription: pair(pairKey: "fitSomewhatSmallTitleDescription") {
    key
    value
  }
  fitTrueTitleDescription: pair(pairKey: "fitTrueTitleDescription") {
    key
    value
  }
  fitSomewhatLargeTitleDescription: pair(pairKey: "fitSomewhatLargeTitleDescription") {
    key
    value
  }
  fitLargeTitleDescription: pair(pairKey: "fitLargeTitleDescription") {
    key
    value
  }
  fitVeryLargeTitleDescription: pair(pairKey: "fitVeryLargeTitleDescription") {
    key
    value
  }
  accordionTitle: pair(pairKey: "detailsAccordionTitle") {
    key
    value
  }
  accordionHeader: pair(pairKey: "detailsAccordionHeader") {
    key
    value
  }
  storeItemNumber: pair(pairKey: "storeItemNumber") {
    key
    value
  }
  webItemNumber: pair(pairKey: "webItemNumber") {
    key
    value
  }
  environmentalQualities: pair(pairKey: "environmentalQualities") {
    key
    value
  }
  selectSizeError: pair(pairKey: "selectSizeError") {
    key
    value
  }
  guestSessionInitError: pair(pairKey: "guestSessionInitError") {
    key
    value
  }
  selectSpecificSizeFieldError: pair(pairKey: "selectSpecificSizeFieldError") {
    key
    value
  }
  shippingAndReturnsAccordionHeaderText: pair(pairKey: "shippingAndReturnsAccordionHeaderText") {
    key
    value
  }
  simpleReturnsContent: pair(pairKey: "simpleReturnsContent") {
    key
    value
  }
  shippingAndHandlingCALeftTab:  pair(pairKey: "shippingAndHandlingCALeftTab") {
    key
    value
  }
  shippingAndHandlingCARightTab:  pair(pairKey: "shippingAndHandlingCARightTab") {
    key
    value
  }
  shippingAndHandlingCAFooter:  pair(pairKey: "shippingAndHandlingCAFooter") {
    key
    value
  }
  shippingAndHandlingUSLeftTab:  pair(pairKey: "shippingAndHandlingUSLeftTab") {
    key
    value
  }
  shippingAndHandlingUSFooter:  pair(pairKey: "shippingAndHandlingUSFooter") {
    key
    value
  }
  noShippingUSContent:  pair(pairKey: "noShippingUSContent") {
    key
    value
}
  shippingAndHandlingAMLeftTab:  pair(pairKey: "shippingAndHandlingAMLeftTab") {
    key
    value
  }
  shippingAndHandlingAMRightTab:  pair(pairKey: "shippingAndHandlingAMRightTab") {
    key
    value
  }
  shippingAndHandlingAMFooter:  pair(pairKey: "shippingAndHandlingAMFooter") {
    key
    value
  }
  shippingAndHandlingWDLeftTab:  pair(pairKey: "shippingAndHandlingWDLeftTab") {
    key
    value
  }
  shippingAndHandlingWDRightTab:  pair(pairKey: "shippingAndHandlingWDRightTab") {
    key
    value
  }
  shippingAndHandlingWDFooter:  pair(pairKey: "shippingAndHandlingWDFooter") {
    key
    value
  }
  shippingAndHandlingEULeftTab:  pair(pairKey: "shippingAndHandlingEULeftTab") {
    key
    value
  }
  shippingAndHandlingEURightTab:  pair(pairKey: "shippingAndHandlingEURightTab") {
    key
    value
  }
  shippingAndHandlingUKLeftTab:  pair(pairKey: "shippingAndHandlingUKLeftTab") {
    key
    value
  }
  shippingAndHandlingUKRightTab:  pair(pairKey: "shippingAndHandlingUKRightTab") {
    key
    value
  }
  shippingAndHandlingUKFooter:  pair(pairKey: "shippingAndHandlingUKFooter") {
    key
    value
  }
  genericCartAPIError: pair(pairKey: "genericCartAPIError") {
    key
    value
  }
  discountPriceDescription: pair(pairKey: "discountPriceDescription") {
    key
    value
  }
  discountRangePriceDescription: pair(pairKey: "discountRangePriceDescription") {
    key
    value
  }
  memberPriceDescription: pair(pairKey: "memberPriceDescription") {
    key
    value
  }
  memberClearance: pair(pairKey: "memberClearance") {
    key
    value
  }
  memberPriceDescriptionRange: pair(pairKey: "memberPriceDescriptionRange") {
    key
    value
  }
  germanIncludeTax: pair(pairKey: "germanIncludeTax") {
    key
    value
  }
  measurementsAccordionTitle: pair(pairKey: "measurementsAccordionTitle") {
    key
    value
  }
  measurementsAccordionLensWidthLabel: pair(pairKey: "measurementsAccordionLensWidthLabel") {
    key
    value
  }
  measurementsAccordionLendWidthTootipHeader: pair(pairKey: "measurementsAccordionLendWidthTootipHeader") {
    key
    value
  }
  measurementsAccordionLensWidthTooltipText: pair(pairKey: "measurementsAccordionLensWidthTooltipText") {
    key
    value
  }
  measurementsAccordionBridgeWidthLabel: pair(pairKey: "measurementsAccordionBridgeWidthLabel") {
    key
    value
  }
  measurementsAccordionBridgeWidthTooltipHeader: pair(pairKey: "measurementsAccordionBridgeWidthTooltipHeader") {
    key
    value
  }
  measurementsAccordionBridgeWidthTooltipText: pair(pairKey: "measurementsAccordionBridgeWidthTooltipText") {
    key
    value
  }
  measurementsAccordionTempleLengthLabel: pair(pairKey: "measurementsAccordionTempleLengthLabel") {
    key
    value
  }
  measurementsAccordionTempleLengthTooltipHeader: pair(pairKey: "measurementsAccordionTempleLengthTooltipHeader") {
    key
    value
  }
  measurementsAccordionTempleLengthTooltipText: pair(pairKey: "measurementsAccordionTempleLengthTooltipText") {
    key
    value
  }
  rangeDiscount: pair(pairKey: "rangeDiscount") {
    key
    value
  }
  rangeListDiscountPricing: pair(pairKey: "rangeListDiscountPricing") {
    key
    value
  }
  rangePriceDescription: pair(pairKey: "rangePriceDescription") {
    key
    value
  }
  discountText: pair(pairKey: "discountText") {
    key
    value
  }
  modelAltImageText: pair(pairKey: "modelAltImageText") {
    key
    value
  }
  lifeAltImageText: pair(pairKey: "lifeAltImageText") {
    key
    value
  }
  prodAltImageText: pair(pairKey: "prodAltImageText") {
    key
    value
  }
  ugcAltImageText: pair(pairKey: "ugcAltImageText") {
    key
    value
  }
  altImagesThumbContainerLabel: pair(pairKey: "altImagesThumbContainerLabel") {
    key
    value
  }
  altImagesThumbItemLabel: pair(pairKey: "altImagesThumbItemLabel") {
    key
    value
  }
  productImageListAlt: pair(pairKey: "productImageListAlt") {
    key
    value
  }  
  mainImageAltText: pair(pairKey: "mainImageAltText") {
    key
    value
  }
  thumbnailImagesAriaLabel: pair(pairKey: "thumbnailImagesAriaLabel") {
    key
    value
  }
  productCarouselAriaLabel: pair(pairKey: "productCarouselAriaLabel") {
    key
    value
  }
  completeLookText: pair(pairKey: "completeLookText") {
    key
    value
  }
  closeText: pair(pairKey: "closeText") {
    key
    value
  }
  swatchGroupLegend: pair(pairKey: "swatchGroupLegend") {
    key
    value
  }
  selectedSize: pair(pairKey: "selectedSize") {
    key
    value
  }
  styliticsHowToStyle: pair(pairKey: "styliticsHowToStyle") {
    key
    value
  }
  styliticsFavoriteWaysToWear: pair(pairKey: "styliticsFavoriteWaysToWear") {
    key
    value
  }
  styliticsTapToReveal: pair(pairKey: "styliticsTapToReveal") {
    key
    value
  }
  styliticsViewDetails: pair(pairKey: "styliticsViewDetails") {
    key
    value
  }
  styliticsModelIsWearing: pair(pairKey: "styliticsModelIsWearing") {
    key
    value
  }
  styliticsStyleItText: pair(pairKey: "styliticsStyleItText") {
    key
    value
  }
  soldoutPageHeading: pair(pairKey: "soldoutPageHeading") {
    key
    value
  }
  soldoutPageMessage: pair(pairKey: "soldoutPageMessage") {
    key
    value
  }
  selectSizeText: pair(pairKey: "selectSizeText") {
    key
    value
  }
  pdpDenimDetails : pair(pairKey: "pdpDenimDetails") {
    key
    value
  }
  pdpCompareFabricLink: pair(pairKey: "pdpCompareFabricLink") {
    key
    value
  }
  pdpViewFullDetails: pair(pairKey: "pdpViewFullDetails") {
    key
    value
  }
  imageMagnifierAriaLabel: pair(pairKey: "imageMagnifierAriaLabel") {
    key
    value
  }
  exchangeColorAndSize: pair(pairKey: "exchangeColorAndSize") {
    key
    value
  }
  originalColorAndSize: pair(pairKey: "originalColorAndSize") {
    key
    value
  }
  newColorAndSize: pair(pairKey: "newColorAndSize") {
    key
    value
  }
  exchangesSave: pair(pairKey: "exchangesSave") {
    key
    value
  }
  exchangeNoLongerAvailable: pair(pairKey: "exchangeNoLongerAvailable") {
    key
    value
  }
  exchangeNoLongerAvailableContactHelp: pair(pairKey: "exchangeNoLongerAvailableContactHelp") {
    key
    value
  }
  pdpOutfittingModelIsWearing: pair(pairKey: "pdpOutfittingModelIsWearing") {
    key
    value
  }
  pdpOutfittingWearItWith: pair(pairKey: "pdpOutfittingWearItWith") {
    key
    value
  }
  pdpStoreAvailability: pair(pairKey: "pdpStoreAvailability") {
    key
    value
  }
  matchingSetCardAriaLabel: pair(pairKey: "matchingSetCardAriaLabel") {
    key
    value
  }
  matchingSetCardAriaLabel: pair(pairKey: "matchingSetCardAriaLabel") {
    key
    value
  }
  matchingSetCarouselNextLabel: pair(pairKey: "matchingSetCarouselNextLabel") {
    key
    value
  }
  matchingSetCarouselPrevLabel: pair(pairKey: "matchingSetCarouselPrevLabel") {
    key
    value
  }
  matchingSetLabel: pair(pairKey: "matchingSetLabel") {
    key
    value
  }
  pdpSliderAriaDescription: pair(pairKey: "pdpSliderAriaDescription") {
    key
    value
  }
  pdpOpenAppToShop: pair(pairKey: "pdpOpenAppToShop") {
    key
    value
  }
  pdpOpenAppToShop: pair(pairKey: "pdpOpenAppToShop") {
    key
    value
  }
  matchingSetPdpHeader: pair(pairKey: "matchingSetPdpHeader") {
    key
    value
  }
  productNotificationSignUp: pair(pairKey: "productNotificationSignUp") {
    key
    value
  }
  notifyMeButton: pair(pairKey: "notifyMeButton") {
    key
    value
  }
  productNotificationTitle: pair(pairKey: "productNotificationTitle") {
    key
    value
  }
  productNotificationDescription: pair(pairKey: "productNotificationDescription") {
    key
    value
  }
  productNotificationSuccess: pair(pairKey: "productNotificationSuccess") {
    key
    value
  }
  productNotificationFooter: pair(pairKey: "productNotificationFooter") {
    key
    value
  }
  continueButton: pair(pairKey: "continueButton") {
    key
    value
  }
  getNotificationsButton: pair(pairKey: "getNotificationsButton") {
    key
    value
  }
  productNotificationError: pair(pairKey: "productNotificationError") {
    key
    value
  }  
  productNotificationEmailError: pair(pairKey: "productNotificationEmailError") {
    key
    value
  }
  placeholderEmailText: pair(pairKey: "placeholderEmailText") {
    key
    value
  }
  pdpFit: pair(pairKey: "pdpFit") {
    key
    value
  }
  pdpAlsoAvailable: pair(pairKey: "pdpAlsoAvailable") {
    key
    value
  }
  termsOfUse: pair(pairKey: "termsOfUse") {
    key
    value
  }
  privacyPolicy: pair(pairKey: "privacyPolicy") {
    key
    value
  }
`;

export default textQueries;
